import App from './App.svelte';

// Nice
var app = new App({
	target: document.body
});

export default app;